import React from 'react'
import styled from '@emotion/styled'
import { Text } from '@organice/atoms'
import { Trans, useTranslation } from 'react-i18next'
import { Divider } from 'antd'
import { Link, useHistory } from 'react-router-dom'
import { notification } from 'antd'
import { useMeContext } from '@organice/contexts'
import { HighlightContainer } from '@organice/organisms/room-planer-history/common/common-styles'

export const AccountMenu = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const {
    logout: logoutMutation,
    state: { me },
  } = useMeContext()
  // const [logoutMutation] = useLogoutMutation()

  const logout = async () => {
    const logoutSuccess = await logoutMutation()

    if (logoutSuccess) {
      history.push('/login')
      return
    } else {
      notification.error({
        duration: 3,
        message: t('logout.error'),
      })
    }
  }

  return (
    <ContextMenuList>
      <ContextMenuListItemUser>
        <Text>
          <Trans
            i18nKey={'account.loggedInAs'}
            values={{
              fullName: `${' '}${me?.firstName} ${me?.lastName}`,
            }}
          >
            <HighlightContainer>
              {/* {{ fullName: `${me?.firstName} ${me?.lastName}` }} */}
            </HighlightContainer>
          </Trans>
        </Text>
      </ContextMenuListItemUser>
      <ContextMenuDivider />
      <ContextMenuActionContainer>
        <ContextMenuListItem>
          <Link to={'/account'}>{t('account.account')}</Link>
        </ContextMenuListItem>
        <ContextMenuListItem onClick={logout}>
          {t('account.logout')}
        </ContextMenuListItem>
      </ContextMenuActionContainer>
    </ContextMenuList>
  )
}

const ContextMenuList = styled.div({
  padding: 0,
  margin: 0,
})

const ContextMenuListItemUser = styled.div(({ theme }) => ({
  listStyleType: 'none',
  padding: '1.25rem',
  display: 'flex',
  alignItems: 'center',
}))

const ContextMenuActionContainer = styled.div(({ theme }) => ({
  padding: '0.5rem 0.75rem',
}))

const ContextMenuListItem = styled.div(({ theme }) => ({
  listStyleType: 'none',
  padding: '0.3125rem 0.625rem',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  transition: 'color .3s',
  borderRadius: theme.borderRadiusBase,

  a: {
    width: '100%',
    display: 'flex',
    '&:hover': {
      color: theme.textColor,
      borderRadius: theme.borderRadiusBase,
    },
  },
  '&:hover': {
    backgroundColor: theme.lightBackground,
  },
}))

const ContextMenuDivider = styled(Divider)({ margin: '0' })
